import Theme from '../../Themes/main.theme';

export const sliderStyles = {
  position: 'relative',
  height: '100%',
} as const;

export const mediaControllersStyles = {
  margin: '10px 15px',
  cursor: 'pointer',
};

export const ImageContainer = {
  position: 'relative',
  width: '90%',
  height: '80%',
  margin: '50px',
};

export const ImageContainerMobile = {
  position: 'relative',
  marginLeft: 'auto',
  padding: '5%'
};

export const ImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  overflow: 'auto',
  zIndex: 9999999999
};

export const modalContentStyle = {
  maxWidth: '100%',
  maxHeight: '100%',
};

export const openTabButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '50px',
  fontSize: '24px',
  color: 'white',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
};

export const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  fontSize: '24px',
  color: 'white',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
};

export const rightArrowStyles = {
  position: 'absolute',
  top: '35%',
  right: '0',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const ;


export const rightArrowStylesMobile = {
  position: 'absolute',
  top: '37%',
  right: '-20px',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const ;

export const leftArrowStyles = {
  position: 'absolute',
  top: '35%',
  left: '0',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

export const leftArrowStylesMobile = {
  position: 'absolute',
  top: '37%',
  left: '-20px',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

export const rightArrowStylesModal = {
  position: 'absolute',
  top: '50%',
  right: '0',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const ;

export const rightArrowStylesMobileModal = {
  position: 'absolute',
  top: '50%',
  right: '0px',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const ;

export const leftArrowStylesModal = {
  position: 'absolute',
  top: '50%',
  left: '0',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

export const leftArrowStylesMobileModal = {
  position: 'absolute',
  top: '50%',
  left: '0px',
  transform: 'translate(0, -50%)',
  fontSize: '45px',
  color: Theme.titleColor?.main,
  zIndex: 1,
  cursor: 'pointer'
} as const;

export const slideStyles = {
  width: '100%',
  height: '100%',
  borderRadius: '10px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
} as const;